import React from 'react';
import { ArrowRight } from 'lucide-react';
import { TEXT_PRIMARY, BG_HOVER, BRAND } from '../styles';

interface Props {
  text: string;
}

export default function TaskItem({ text }: Props) {
  return (
    <li style={{
      display: 'flex', alignItems: 'flex-start', gap: 9,
      fontSize: 13.5, color: TEXT_PRIMARY, lineHeight: 1.55,
    }}>
      <span style={{
        flexShrink: 0, width: 18, height: 18, borderRadius: '50%',
        background: BG_HOVER, display: 'grid', placeItems: 'center', marginTop: 1,
      }}>
        <ArrowRight size={11} style={{ color: BRAND }} />
      </span>
      <span>{text}</span>
    </li>
  );
}